<script lang="ts" setup>
import {computed} from 'vue';
import {store} from '@/store';
import AlertComp from '@/components/pages/popup/comp/AlertComp.vue';

const alertList = computed(() => {
  return store.state.popup.alert;
});

const onConfirm = () => {
  store.state.popup.alert.pop()
}
const curAlert = computed(() => {
  return alertList.value[alertList.value.length - 1]
})
</script>

<template>
  <div class="alert-popup-view" v-if="alertList.length">
    <div class="alert-back">
      <AlertComp
          v-if="curAlert"
          :text="curAlert.text"
          :options="curAlert.options"
          @confirm="onConfirm"
      />
    </div>
  </div>
</template>

